import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=6dee4804&scoped=true&lang=pug&"
import script from "./Server.vue?vue&type=script&lang=ts&"
export * from "./Server.vue?vue&type=script&lang=ts&"
import style0 from "./Server.vue?vue&type=style&index=0&id=6dee4804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dee4804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSheet,VSkeletonLoader})
